import React from 'react';

import { Text } from 'components/Text';

import { StyledHref, StyledTable, StyledTH, StyledUnorderedList } from './TermsPage.style';

export const TERMS = [
    {
        paragraphs: ['Bitnite, LLP is the copyright holder of the Widgetter software Widgetter (hereinafter referred to as the application).'],
    },
    {
        paragraphs: [
            'The subject of this license agreement is to grant you (the user) a non-exclusive right to use Widgetter, the copyright holder of which is Bitnite, LLP, as well as the rights and obligations of the Copyright Holder and the User.',
        ],
    },
    {
        paragraphs: [
            'The Copyright Holder asks users to read this license agreement carefully before downloading and installing the Application on their computer. By downloading, installing, and / or using Widgetter, the User agrees to comply with the terms of the License Agreement and be guided by its provisions when using Widgetter.',
        ],
    },
    {
        paragraphs: [
            [
                'Also, granting a non-exclusive right of use depends on the User’s consent and compliance with the Privacy Policy of the Copyright Holder, as well as the Refund Policy. Before using the Application, the User should read the Privacy Policy available at: ',
                <StyledHref key={1} href="https://widgetter.com/privacy" target={'_blank'} rel="noreferrer">
                    https://widgetter.com/privacy
                </StyledHref>,
                ', as well as with the Refund Policy ',
                <StyledHref key={3} href="https://widgetter.com/refund-policy" target={'_blank'} rel="noreferrer">
                    https://widgetter.com/refund-policy
                </StyledHref>,
            ],
        ],
    },
    {
        paragraphs: [
            'If the User does not agree with the terms of the License Agreement, Privacy Policy, or Refund Policy, the User must stop using Widgetter anddelete it from their Device.',
        ],
    },

    {
        title: 'Article 1. Terms and definitions',
        paragraphs: [
            '1.  Widgetter / application – software (application) that allows the User to optimize the workspace on the computer, including optimizing controls, collecting basic information about computer performance.',
            'The Application’s functionality is described on the Website, as well as in the Application itself.',
            'The Application includes:',
            <StyledUnorderedList key={3}>
                <li>registration information;</li>
                <li>documentation (installation instructions, etc.);</li>
                <li>installation files.</li>
            </StyledUnorderedList>,
            'The Application includes all updates and modifications provided by the Copyright Holder to the User.',
            [
                '2. Website – website ',
                <StyledHref key={1} href="https://widgetter.com/" target={'_blank'} rel="noreferrer">
                    https://widgetter.com/
                </StyledHref>,
                ' from which the User can download the Application. The Site also includes all subdomains of the Site.',
            ],
            '3. Subscription - the amount of rights granted to the User for a fee, depending on the Application functionality provided to the User for the period paid by the User.',
            '4. Basic version of the Application - the version of the Application whose list of functionalities is limited. The list of available functionalities is reflected in the Application.',
            '5. Device – a personal Mac computer (of any model) that is legally owned by the User.',
            '6. User – an individual who uses the Application.',
            '7. The Payment Provider – legal entity Paddle LLC, authorized by the Copyright Holder to accept payments from the User.',
        ],
    },

    {
        title: 'Article 2. General terms of use of the License Agreement',
        paragraphs: [
            <i key={0}>Making changes to the License Agreement</i>,
            '1. The Copyright Holder has the right to make changes to the License Agreement at its own discretion at any time, including in the event of changes to the functionality of the Application. ',
            '2. The new version of the License Agreement is applied from the moment the new version of the License Agreement is published on the Site.',
            '3. The version posted on the Site is up-to-date.',
            '4. The Copyright Holder notifies the User of any changes to the License Agreement.',
            '5. The Copyright Holder strongly recommends the User to reread the License Agreement before each launch of the Application.',
            '6. If the User uses the Application after making changes to the License Agreement, this means that the User agrees to the new version of the License Agreement. ',
            '7. If the User does not agree with the new version of the License Agreement, the User must stop using the Application and remove it from the Device. In this case, the License Agreement terminates itsе validity in accordance with Article 10 of the License Agreement.',
            <i key={8}>Beginning of the License Agreement</i>,
            '8. The License Agreement for the Basic Version is valid from the moment the User starts using the Application.',
            '9. The Subscription License Agreement for the Subscription is valid from the moment you pay for the subscription.',
        ],
    },

    {
        title: 'Article 3. Protection of the rights of the Copyright Holder. Permitted use and restrictions on the use of the Application',
        paragraphs: [
            <i key={0}>Protecting the rights of the Copyright Holder</i>,
            '1. The application is the object of copyright of the Copyright Holder and is protected by laws on the protection of intellectual property, international treaties on intellectual property. ',
            '2. The application is protected by copyright, trademarks and other laws of the Republic of Kazakhstan and foreign countries.',
            <i key={3}>Permitted use and restrictions on the use of the Application</i>,
            '3. The Copyright Holder grants the User a non-exclusive, limited, revocable, non-transferable license to use the Application, taking into account the following features (permitted use):',
            <StyledUnorderedList key={5}>
                <li>
                    The User cannot use the Application provided by Subscription (clauses 4-12 of Article 5 of the License Agreement)
                    on multiple devices.
                </li>
                <li>
                    The user can use the Basic version of the Application (clause 2-3 of Article 5 of the License Agreement)
                    on multiple devices without restriction.
                </li>
            </StyledUnorderedList>,
            '4. The User may not (restrictions):',
            <StyledUnorderedList key={6}>
                <li>
                    sell, distribute, sublicense, or assign the Application without the written consent of the Copyright Holder.
                </li>
                <li>сopy the Application.</li>
                <li>use the Application in ways that are not provided for in the License Agreement.</li>
                <li>
                    use the Application for criminal and illegal activities, as well as for purposes, that contradict the current rules,
                    or violate the rights of third parties (including intellectual property rights).
                </li>
                <li>
                    decompile, disassemble, reconstruct, or create intellectual property objects based on the Application and its parts.
                </li>
                <li>attempt to bypass the technical restrictions operated in the Application.</li>
                <li>
                    use third-party programs or other tools to improve and automate the Application’s functionality.
                </li>
                <li>Restrict the use of the Application in any way.</li>
                <li>
                    distribute the content of the Application (including by distributing screen shots, screen recordings)
                    without the prior written permission of the Copyright Holder. 
                </li>
            </StyledUnorderedList>,
            '5. The Copyright Holder has the right to terminate the License Agreement if the User violates one of the restrictions in accordance with Article 10 of the License Agreement.',
        ],
    },

    {
        title: 'Article 4. Procedure for using the Application',
        paragraphs: [
            '1. To start using the Application, you need to download the installation file to your computer by clicking the "Download now" button and install the Application in accordance with the instructions.',
            '2. User Warranties:',
            <StyledUnorderedList key={2}>
                <li>
                    The characteristics of the User’s Device correspond to the characteristics specified on the Site.
                </li>
                <li>The User is an adult in accordance with the legislation of his place of residence. If the User is a minor, they must obtain consent from their legal representative.</li>
                <li>
                    by entering bank card details to pay for a subscription, the User confirms that they are the cardholder or an authorized representative of the cardholder.
                </li>
            </StyledUnorderedList>,
            '3. The User must use the Application within the limits of permitted use, subject to the restrictions set out in the License Agreement.',
        ],
    },

    {
        title: 'Article 5. Content of the Basic Version and content of Subscriptions',
        paragraphs: [
            <i key={2}>Basic version</i>,
            '1. The Basic version starts working from the moment the Application is installed on the Device.',
            '2. The functionality of the Basic version is listed in the Application.',
            <i key={5}>Subscription</i>,
            '3. The subscription is paid.',
            '4. You can subscribe in the Application by selecting the appropriate subscription type:',
            <StyledUnorderedList key={8}>
                <li>subscription for one year.</li>
                <li>monthly subscription.</li>
                <li>unlimited subscription.</li>
            </StyledUnorderedList>,
            '5. The subscription functionality is listed in the Application.',
            '6. Validity period:',
            <StyledUnorderedList key={9}>
                <li>subscription for one year – one year from the date of payment.</li>
                <li>monthly subscription – one month from the date of payment.</li>
                <li>perpetual subscription – for the duration of the exclusive right to the Application in accordance with the requirements of applicable law.</li>
            </StyledUnorderedList>,
            '7. The User pays for the subscription based on the selected validity period by entering the appropriate data in the Application.',
            '8. The price of the selected subscription type is indicated in the Application.',
            [
                '9. Payment for a Subscription is made using the Payment Provider’s functionality. By paying for a Subscription, the User also enters into an agreement with the Payment Provider. Your relationship with the Payment Provider is regulated by ',
                <StyledHref key={1} href="https://www.paddle.com/legal/privacy" target={'_blank'} rel="noreferrer">
                    https://www.paddle.com/legal/privacy.
                </StyledHref>,
            ],
            '10. The renewal fees are automatically charged on the last day of the subscription period. If the card details are invalid or there are not enough funds in the account to pay for the subscription, the Right Holder terminates access to the Application.',
            '11. Before renewing the Subscription, the User has the right to cancel the Subscription for the next period no later than the last day of the subscription validity period. In this case, the Subscription expires on the last day of the Subscription period.',
            '12. If the User wants to resume access after stopping access to the Application, he can do so in the Application.',
            [
                '13. Refund of funds is carried out in accordance with the procedure established in the Refund Policy ',
                <StyledHref key={1} href="https://widgetter.com/refund-policy" target={'_blank'} rel="noreferrer">
                    https://widgetter.com/refund-policy.
                </StyledHref>,
            ],
            '14. The Right holder has the right to change the subscription price. The Right Holder increases the cost of the subscription only when the User makes a new subscription. The changed Subscription cost does not apply to the Subscriptions already active and paid by the User.',
            <i key={10}>Trial period, special offers</i>,
            '15. The Copyright Holder has the right to set trial periods of Subscription validity, as well as special offers for purchasing a Subscription.',
            '16. The terms of validity of the trial periods and special offers will be displayed in the Application in separate sections of the Application.',
            '17. The Copyright Holder has the right to withdraw or change the Trial Period at any time without prior notice and without any liability to the extent permitted by applicable law.',
            '18. The User agrees that the Copyright Holder can automatically start charging the User a Subscription fee on the first day after the end of the Trial Period, at a recurring interval, which will be provided in advance with information to the User. If the User wishes to waive such a fee, they must cancel the applicable subscription in accordance with article 5 (10) of the License Agreement. If the User cancels the access renewal, they lose access to the Subscription immediately after the trial period expires. In this case, the User can continue using the Application in accordance with the terms of the Basic Version.',
        ],
    },

    {
        title: 'Article 6. Application Updates',
        paragraphs: [
            '1. The Copyright Holder updates the Application at its own discretion.',
            '2. The Copyright Holder has the right to add or remove any Application features at its sole discretion, with or without prior notice.',
            '3. The Copyright Holder has the right to send a notification to the User about the need to update the Application due to the availability of a new version of the Application or an automatic update of the Application.',
            '4. The Copyright Holder has the right not to support previous versions of the Application when updates or subsequent versions of the Application appear.',
            '5. The Copyright Holder has the right to make changes to the License Agreement if the Application is updated (Article 2).',
        ],
    },

    {
        title: 'Article 7. Suspension of use of the Application',
        paragraphs: [
            '1. The Copyright Holder has the right to suspend / terminate the Application without prior notice to the User, compensation for damages, and without liability:',
            <StyledUnorderedList key={1}>
                <li>if this is necessary for troubleshooting, maintenance, or other similar actions.</li>
                <li>if the User has not paid for an extension of the Subscription validity period.</li>
                <li>
                    if the User has violated the restrictions (Article 3), as well as other terms of the License Agreement.
                </li>
            </StyledUnorderedList>,
        ],
    },

    {
        title: 'Article 8. Personal data',
        paragraphs: [
            '1. The User confirms that they have read, read and agreed to the Privacy Policy.',
            '2. The Copyright Holder collects and uses technical and related information to improve the Application’s performance. The copyright Holder cannot identify the User based on this information.',
            '3. The Сopyright holder uses the following services for collecting technical and related information:',
            <StyledTable key={3}>
                <thead>
                    <tr>
                        <StyledTH width="200px">
                            <Text fontWeight="700">Service name</Text>
                        </StyledTH>
                        <StyledTH>
                            <Text fontWeight="700">Type of information processed</Text>
                        </StyledTH>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <StyledTH>Sentry</StyledTH>
                        <StyledTH>
                            <ul>
                                <li>Information about Application failures Application crashes</li>
                                <li>Information about Application failures</li>
                                <li>Information about errors during use</li>
                                <li>Information about the device, OS version: device model, amount of memory, IP address</li>
                            </ul>
                        </StyledTH>
                    </tr>
                    <tr>
                        <StyledTH>RevenueCat</StyledTH>
                        <StyledTH>
                            Information about subscription payments made by the User, subscription renewal, number of payments.
                        </StyledTH>
                    </tr>
                    <tr>
                        <StyledTH>Posthog</StyledTH>
                        <StyledTH>The User’s actions in the Application and how the Application works</StyledTH>
                    </tr>
                    <tr>
                        <StyledTH>BugSnag</StyledTH>
                        <StyledTH>Application Errors</StyledTH>
                    </tr>
                    <tr>
                        <StyledTH>Doorbell</StyledTH>
                        <StyledTH>User feedback about how the Application works</StyledTH>
                    </tr>
                </tbody>
            </StyledTable>,
        ],
    },

    {
        title: 'Article 9. Liability',
        paragraphs: [
            '1. The application is provided "as is".',
            '2. The Copyright Holder does not guarantee that the Application meets the User’s expectations, is provided continuously, quickly, reliably and error-free, and will be available at any time.',
            '3. The Copyright holder is not responsible for:',
            <StyledUnorderedList key={3}>
                <li>
                    specialized resources and quality of public communication network channels used to access the Application, as well as those caused by interruptions in the provision of services by contractors and third parties;
                </li>
                <li>Device breakdowns or other malfunctions that occurred while using the Application.</li>
                <li>
                    consequences caused by the User’s loss or disclosure of their data required to access the Application.
                </li>
                <li>
                    errors and / or violations related to the use of the Application and caused by illegal actions of third parties;
                </li>
                <li>
                    crashes and interruptions in the Application caused by force majeure.
                </li>
                <li>
                    failures and interruptions in the Application caused by actions of state authorities, including law enforcement agencies, to seize and / or confiscate or otherwise obstruct access to the servers of counterparties hosting the Application, as well as due to the introduction of sanctions;
                </li>
            </StyledUnorderedList>,
            '4. The Copyright Holder’s liability may not exceed the amount of payment transferred by the User.',
        ],
    },

    {
        title: 'Article 10. Termination of the License Agreement',
        paragraphs: [
            <i key={0}>Validity period</i>,
            '1. The term of validity of the License Agreement corresponds to the term of validity of the Subscription for paid functionality, for the Basic Version for the period of using the Application.',
            <i key={2}>Termination</i>,
            '2. The User has the right to cancel the terms of the License Agreement by deleting the Application from the Device.',
            '3. The Copyright Holder has the right to terminate the License Agreement in the following cases:',
            <StyledUnorderedList key={5}>
                <li>User’s violation of the terms of the License Agreement (including restrictions);</li>
                <li>
                    existence of the Right Holder’s obligation in accordance with the law or a resolution of the authorized body.
                </li>
            </StyledUnorderedList>,
            'In this case, the Copyright Holder terminates the Application on the User’s device.',
        ],
    },

    {
        title: 'Article 11. Settlement of disputes',
        paragraphs: [
            '1. The User and the Copyright Holder must comply with the pre-trial (claim) dispute resolution procedure.',
            '2. The deadline for responding to a claim is 10 (ten) business days from the date of its receipt by the Receiving Party.',
            '3. If it is impossible to resolve the dispute in a claim-based manner, the dispute is subject to consideration in court in accordance with the legislation of the Republic of Kazakhstan.',
            '4. When interpreting the terms of the Agreement and resolving disputes, the legislation of the Republic of Kazakhstan is applied. ',
        ],
    },

    {
        title: 'Article 12. Final provisions',
        paragraphs: [
            '1. The license agreement is written in English. If there is any disagreement between the translated version and the English version, the English version will apply.',
            '2. No condition denies the User’s rights under local law. If there are contradictions, the right of the consumer’s location is subject to application.',
            '3. Invalidating a certain condition does not mean invalidating the entire License Agreement.',
            [
                '4. The current version of the License Agreement is available on the page at: ',
                <StyledHref key={1} href="https://widgetter.com/terms" target={'_blank'} rel="noreferrer">
                    https://widgetter.com/terms.
                </StyledHref>,
            ],
        ],
    },

    {
        title: 'Contact details:',
        paragraphs: [
            'Bitnite, LLP.',
            'BIN: 220840009542',
            'The Republic of Kazakhstan. Almaty city, st. Zhandosova 1/1, (Business center "Success"), 2nd floor.',
        ],
    },
];
